import { create } from 'zustand';

export const useFacturaStore = create((set) => ({
  detalleFacturaProveedor: [],
  detalleFactura: [],
  // Objeto completo de la factura seleccionada/actual
  facturaActual: null,
  setDetalleFactura: (payload) => set({ detalleFactura: payload }),
  setDetalleFacturaProveedor: (payload) => set({ detalleFacturaProveedor: payload }),  
  // Setter para almacenar la factura completa
  setFacturaActual: (payload) => set({ facturaActual: payload }),
}));